import { TextInputField } from 'components/Form/TextInputField'
import Styles from '../../../BlogMetadata.module.scss'
import { TextFieldSize } from 'components/Form/useTextFieldCounter'

interface SlugFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  size?: TextFieldSize
}

export const SlugField: React.FC<SlugFieldProps> = ({ value, onChange, size = 'lg' }) => (
  <TextInputField
    wrapperClassName={Styles.inputField}
    label="URL Slug"
    value={value}
    onChange={onChange}
    size={size}
    labelClassName={Styles.textFieldLabel}
  />
)
